export default "__VITE_ASSET__CjX4u5Ba__"